module.exports = require('./helpers/bundle-url').getBundleURL('3ufsE') + "background.bf75fd73.webp";